import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import Tooltip from 'react-tooltip-lite';
import {
  DESKTOP_TOOLTIP_DISTANCE,
  SHARED_TOOLTIP_DISTANCE,
} from '../../../constants/breakpoints';
import useIsMobile from '../../../hooks/useIsMobile';

const iconSvg = (type?: string) => {
  switch (type) {
    case 'floorplan':
      return 'floorplans.svg';
    case 'room-capacity':
      return 'room-capacity.svg';
    case 'capacity':
      return 'capacity.svg';
    case 'favourite-off':
      return 'favourite-off.svg';
    case 'favourite-on':
      return 'favourite-on.svg';
    default:
      return null;
  }
};

const FeatureIcon = ({
  type,
  name,
  additionalText,
  icon,
  iconAltText,
  displaySvgIcon,
}: {
  type?: string;
  name: string;
  additionalText?: string;
  icon?: string;
  iconAltText?: string;
  displaySvgIcon?: boolean;
}) => {
  const nameType = () => {
    return name.toLowerCase().replace(/ /g, '-');
  };

  const featureIconClasses = classNames({
    'feature-icon': true,
    [`feature-icon--${type || nameType()}`]: true,
  });

  const isMobileView = useIsMobile();

  return (
    <span className={featureIconClasses}>
      {displaySvgIcon && (
        <Tooltip
          content={iconAltText || name}
          distance={
            isMobileView ? SHARED_TOOLTIP_DISTANCE : DESKTOP_TOOLTIP_DISTANCE
          }
        >
          <ReactSVG
            className="feature-icon__svg"
            src={`/images/icons/bookings/${iconSvg(type)}`}
            data-testid={type}
          />
        </Tooltip>
      )}
      {icon && (
        <Tooltip
          content={iconAltText || name}
          distance={
            isMobileView ? SHARED_TOOLTIP_DISTANCE : DESKTOP_TOOLTIP_DISTANCE
          }
        >
          <img
            className="feature-icon__img"
            src={icon}
            alt={iconAltText || name}
            data-testid={nameType()}
          />
        </Tooltip>
      )}
      <span className="feature-icon__name">{name}</span>
      {additionalText && (
        <span className="feature-icon__additional-text">{additionalText}</span>
      )}
    </span>
  );
};

export default FeatureIcon;
